import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { OrderCreationService } from '../../../../Services/order-creation.service';
import { NotificationService } from '../../../../Services/notification.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import Swal from 'sweetalert2';
interface Order {
  id: number;
  ordc_handover_status: 'pending' | 'handed_over';
}
@Component({
  selector: 'app-orders-creation',
  standalone: true,
  imports: [NgFor, NgIf, FormsModule, ReactiveFormsModule, RouterLink],
  templateUrl: './orders-creation.component.html',
  styleUrl: './orders-creation.component.css'
})
export class OrdersCreationComponent implements OnInit {
  orderCreationForm!: FormGroup;
  completedProductCodes: any[] = [];
  metalDataList: any;
  orederCreationDataList: any;
  selectedFirm: any;
  completeProductData: any;
  totalMetalPrice: any;
  totalStonePrice: any;
  finalValue: any;
  kalakarSuppliers: any;
  data: any[] = [];
  productId!: number;
  consolidatedRawMaterialList: any[] = [];
  order: any[] | undefined;
  kalakarOrderSummary: any[] = [];
  kalakarMetalConsolidation: any[] = [];
  kalakarStoneConsolidation: any[] = [];
  activeTab: 'metal' | 'stone' = 'metal';




  constructor(
    private fb: FormBuilder,
    private orderCreationService: OrderCreationService,
    private notificationService: NotificationService,
    private firmSelectionService: FirmSelectionService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
      if (!firm || !firm.id) {
        return;
      }
      this.selectedFirm = firm.id;
      this.initForm();
      this.getProductCodes();
      this.getAssignedName(() => {
        // THEN LOAD ORDERS
        this.getOrderCreationDataList();
      });
      // this.getAssignedName();
      // this.getOrderCreationDataList();

      this.orderCreationForm.get('ordc_quantity')?.valueChanges.subscribe(() => {
        this.updateCalculatedMetalAndStoneData();
        this.updateLabourCharges();
      });

      this.orderCreationForm.get('per_piece_labour_charges')?.valueChanges.subscribe(() => {
        this.calculateTotalLabourCharges();
      });

      this.orderCreationForm.get('ordc_quantity')?.valueChanges.subscribe(() => {
        this.calculateTotalLabourCharges();
      });
    });
  }

  initForm() {
    this.orderCreationForm = this.fb.group({
      ordc_product_code: ['', Validators.required],
      ordc_product_name: [''],
      ordc_category_id: [''],
      ordc_quantity: ['', Validators.required],
      ordc_assined_to: ['', Validators.required],
      ordc_metal_price: [''],
      ordc_stone_price: [''],
      ordc_final_value: [''],
      ordc_metal_details: [''],
      ordc_stone_details: [''],
      per_piece_labour_charges: ['', Validators.required],
      ordc_labour_charges: [''],
      ordc_is_labour_applicable: false,
      ordc_firm_id: this.selectedFirm,
      ordc_image: [''],
      ordc_silver_rate: [''],
      ordc_packaging_cost: [''],
      ordc_per_gm_cost_without_packaging: [''],
      ordc_packaging_stack_id: [''],
    });
  }

  //this is fo kalakar raw material 
  buildKalakarWiseSummary() {
    const map = new Map<string, any>();

    this.orederCreationDataList.forEach((order: any) => {
      const id = String(order.assignee_id || order.ordc_assined_to);
      const name = order.assignee_name;

      if (!map.has(id)) {
        map.set(id, {
          kalakar: name,
          total_orders: 0,
          total_qty: 0
        });
      }

      const row = map.get(id);
      row.total_orders += 1;
      row.total_qty += Number(order.quantity || 0);
    });

    this.kalakarOrderSummary = Array.from(map.values());
  }



  handleAssigneeChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const userId = selectElement.value;
    this.onAssigneeSelected(userId);
  }


  getAssignedName(done?: () => void) {
    this.orderCreationService.getKalakarSuppliers().subscribe((response: any) => {
      this.kalakarSuppliers = response.data ?? [];
      done?.(); // 🔥 signal that kalakars are ready
    });
  }

  // getAssignedName() {
  //   this.orderCreationService.getKalakarSuppliers().subscribe((response: any) => {
  //     this.kalakarSuppliers = response.data ?? [];

  //     if (this.orederCreationDataList?.length) {
  //       this.orederCreationDataList = this.mapOrdersWithNames(this.orederCreationDataList);

  //       // rebuild AFTER correct names
  //       this.buildKalakarWiseSummary();
  //       this.buildKalakarWiseMetal();
  //       this.buildKalakarWiseStone();
  //     }
  //   });
  // }



  onAssigneeSelected(userId: string) {
    const selectedUser = this.kalakarSuppliers.find((u: any) => u.id == userId);
    if (selectedUser) {
      this.orderCreationForm.get('ordc_assined_to')?.setValue(userId);
      const fullName = `${selectedUser.name ?? ''} ${selectedUser.user_last_name ?? ''}`.trim();
    }
  }


  getProductCodes() {
    let params = new HttpParams().set('firm_id', this.selectedFirm);
    this.orderCreationService.getGeneralProductCodeForProductDesign(params).subscribe((res: any) => {
      this.completedProductCodes = res.data;
    });
  }

  onProductCodeChange(event: Event) {
    this.completeProductData = null;
    this.totalMetalPrice = 0;
    this.totalStonePrice = 0;
    this.finalValue = 0;

    this.orderCreationForm.patchValue({
      ordc_product_name: '',
      ordc_image: '',
      ordc_metal_details: '',
      ordc_stone_details: '',
      ordc_quantity: ''
    });

    const selectedCode = (event.target as HTMLSelectElement).value;

    const selectedProduct = this.completedProductCodes.find(
      item => item.model_number === selectedCode
    );

    this.completeProductData = selectedProduct;
    

    if (selectedProduct) {
      this.orderCreationForm.patchValue({
        ordc_product_code: selectedProduct.model_number,
        ordc_product_name: selectedProduct.product_name || '',
        ordc_category_id: selectedProduct.category_id || '',
        per_piece_labour_charges: '',
        ordc_silver_rate: selectedProduct?.latest_product_price?.silver_rate,

        ordc_packaging_cost: selectedProduct?.packaging[0]?.total_price,
        ordc_per_gm_cost_without_packaging: selectedProduct?.latest_product_price?.purchase_price,
        ordc_packaging_stack_id: selectedProduct?.packaging[0]?.st_packaging_stack_id, //PASS THE ID FROM STOCK TABLE NOW IN RESPONSE IT GETTING FROM MASTER

        ordc_image: selectedProduct.product_image || selectedProduct.product_image_2 || selectedProduct.product_image_3 || selectedProduct.product_image_4 || selectedProduct.product_image_5,
      });

      this.orderCreationForm.patchValue({
        ordc_is_labour_applicable: false
      });

      // Total metal price
      this.totalMetalPrice = selectedProduct.assembly_metal_part?.reduce(
        (sum: number, item: any) => sum + (+item.total_price || 0), 0
      ) || 0;

      // Total stone price
      this.totalStonePrice = selectedProduct.assembly_stone?.reduce(
        (sum: number, item: any) => sum + (+item.total_price || 0), 0
      ) || 0;

      this.finalValue = this.totalMetalPrice + this.totalStonePrice;

      // Format metal data as JSON (object if 1 item, array if >1)
      const metalData = selectedProduct.assembly_metal_part;
      const formattedMetal = metalData?.length === 1 ? metalData[0] : metalData;

      // Format stone data as JSON (object if 1 item, array if >1)
      const stoneData = selectedProduct.assembly_stone;
      const formattedStone = stoneData?.length === 1 ? stoneData[0] : stoneData;

      this.orderCreationForm.patchValue({
        ordc_metal_details: JSON.stringify(formattedMetal),
        ordc_stone_details: JSON.stringify(formattedStone)
      });
    } else {
      this.orderCreationForm.patchValue({
        ordc_product_name: '',
        ordc_quantity: ''
      });
    }
  }

  validateAndAssignOrder(): void {
    // 1. Basic Form Validation
    if (this.orderCreationForm.invalid) {
      this.notificationService.showError('Please fill all required fields.', 'Validation Error');
      this.orderCreationForm.markAllAsTouched();
      return;
    }
    const quantity = this.orderCreationForm.get('ordc_quantity')?.value;
    if (!quantity || quantity <= 0) {
      this.notificationService.showError('Please enter a quantity greater than 0.', 'Validation Error');
      return;
    }
    if (!this.selectedFirm) {
      this.notificationService.showError('Firm not selected. Please select a firm first.', 'Error');
      return;
    }

    // 2. Gather required materials from the selected product
    const allMaterials = [
      ...(this.completeProductData?.assembly_metal_part || []),
      ...(this.completeProductData?.assembly_stone || [])
    ];

    // If there are no raw materials, we can assign the order directly
    if (allMaterials.length === 0) {
      this.addOrderCreationData();
      return;
    }

    const materialCodes = allMaterials.map(m => m.code);

    // 3. Call the service to get current stock levels for the required materials
    this.orderCreationService.checkStockAvailability(materialCodes, this.selectedFirm).subscribe({
      next: (response) => {
        const availableStocks = response.data;
        const shortages: string[] = [];

        // 4. Compare required materials with available stock
        allMaterials.forEach(material => {
          const requiredQty = (parseFloat(material.quantity) || 0) * quantity;
          const stockInfo = availableStocks.find((s: any) => s.st_item_code === material.code);

          if (!stockInfo) {
            shortages.push(`<li><b>${material.artical_name || material.stone_name} (${material.code})</b>: Not found in stock.</li>`);
          } else {
            // Check quantity (for both metal and stone)
            if (parseFloat(stockInfo.st_quantity) < requiredQty) {
              shortages.push(`<li><b>${material.artical_name || material.stone_name} (${material.code})</b>: Required Qty: ${requiredQty}, Available: ${stockInfo.st_quantity}</li>`);
            }
            // Additional check for weight (only for metal)
            if (material.per_piece_weight) {
              const requiredWeight = requiredQty * (parseFloat(material.per_piece_weight) || 0);
              if (parseFloat(stockInfo.st_total_wt) < requiredWeight) {
                shortages.push(`<li><b>${material.artical_name} (${material.code})</b>: Required Wt: ${requiredWeight.toFixed(2)}gm, Available: ${parseFloat(stockInfo.st_total_wt).toFixed(2)}gm</li>`);
              }
            }
          }
        });

        // 5. Handle the result of the check
        if (shortages.length > 0) {
          this.showStockShortageAlert(shortages);
        } else {
          // If stock is sufficient, proceed with creating the order
          this.addOrderCreationData();
        }
      },
      error: (err) => {
        this.notificationService.showError('Could not verify stock levels. Please try again.', 'API Error');
        console.error('Error checking stock availability:', err);
      }
    });
  }

  /**
   * NEW: Helper function to display the SweetAlert2 popup with shortage details.
   */
  private showStockShortageAlert(shortages: string[]): void {
    const messageHtml = `
        <div style="
          text-align: center;
          font-size: 17px;
          color: #c19725;
          margin-bottom: 10px;
        ">
          <b>The order cannot be assigned due to insufficient raw materials:</b>
        </div>
      
        <ul style="
          text-align: left;
          list-style: disc;
          margin-left: 20px;
          color: #000;
          font-size: 14px;
          line-height: 1.5;
        ">
          ${shortages.join('')}
        </ul>
      `;

    Swal.fire({
      title: '<span style="color:#ff0000ff; font-weight:700; font-size:22px;">Insufficient Stock!</span>',
      html: messageHtml,
      icon: 'error',
      width: '600px',
      padding: '20px 25px',
      showCancelButton: true,
      showDenyButton: true,

      cancelButtonText: 'OK',
      confirmButtonText: 'Add Metal',
      denyButtonText: 'Add Stone',

      customClass: {
        cancelButton: 'btn-ok',
        popup: 'wide-alert-popup',
        confirmButton: 'btn-add-metal',
        denyButton: 'btn-add-stone',
      }
    }).then(result => {
      if (result.isConfirmed) {
        this.router.navigate(['/raw-metal/metal']);
      }
      else if (result.isDenied) {
        this.router.navigate(['/raw-metal/stone']);
      }
    });
  }

  buildRawMaterialConsolidation() {
    const map = new Map<string, any>();

    this.orederCreationDataList.forEach((order: any) => {
      const metals = Array.isArray(order.ordc_metal_details)
        ? order.ordc_metal_details
        : [order.ordc_metal_details];

      metals.forEach((metal: any) => {
        const key = metal.code; // MT0001

        if (!map.has(key)) {
          map.set(key, {
            code: metal.code,
            name: metal.artical_name,
            total_qty: 0,
            total_weight: 0
          });
        }

        const row = map.get(key);
        row.total_qty += Number(metal.calculated_product_qty || 0);
        row.total_weight += Number(metal.total_silver || 0);
      });
    });

    this.consolidatedRawMaterialList = Array.from(map.values());
  }

  addOrderCreationData() {
    if (!this.completeProductData) return;

    const metalList = this.completeProductData.assembly_metal_part?.map((metal: any) => {
      const calculatedQty = this.getMetalProductQuantity(metal);
      const totalSilver = this.getTotalSilverMetal(metal);
      return {
        ...metal,
        calculated_product_qty: calculatedQty,
        total_silver: totalSilver
      };
    });

    const stoneList = this.completeProductData.assembly_stone?.map((stone: any) => {
      const calculatedQty = this.getStoneProductQuantity(stone);
      const totalStone = this.getTotalStone(stone);
      return {
        ...stone,
        calculated_product_qty: totalStone,
        total_stone: totalStone
      };
    });

    const formattedMetal = metalList?.length === 1 ? metalList[0] : metalList;
    const formattedStone = stoneList?.length === 1 ? stoneList[0] : stoneList;

    const availableQty = this.orderCreationForm.get('ordc_quantity')?.value;

    this.totalMetalPrice = metalList?.reduce((sum: number, m: any) => sum + (+m.total_price || 0), 0) || 0;
    this.totalStonePrice = stoneList?.reduce((sum: number, s: any) => sum + (+s.total_price || 0), 0) || 0;
    this.finalValue = this.totalMetalPrice + this.totalStonePrice;
    const formData = {
      ...this.orderCreationForm.value,
      ordc_available_quantity: availableQty,
      ordc_metal_price: this.totalMetalPrice,
      ordc_stone_price: this.totalStonePrice,
      ordc_final_value: this.finalValue,
      ordc_metal_details: JSON.stringify(formattedMetal),
      ordc_stone_details: JSON.stringify(formattedStone),
      ordc_request_status: 'production_order'

    };

    this.orderCreationService.createOrder(formData).subscribe(
      (res: any) => {
        this.notificationService.showSuccess('Order Created Successfully!', 'Success');
        this.clearForm();
        this.getOrderCreationDataList();
        this.buildRawMaterialConsolidation();

      },
      (error: any) => {
        console.error('❌ Error creating order:', error);
        this.notificationService.showError('Failed to create order. Please try again.', 'Error');
      }
    );
  }

  clearForm() {
    this.orderCreationForm.reset({
      ordc_firm_id: this.selectedFirm,
      ordc_product_code: '',
      ordc_assined_to: '',
    });
    this.completeProductData = null;
    this.totalMetalPrice = 0;
    this.totalStonePrice = 0;
    this.finalValue = 0;
  }

  getOrderCreationDataList() {
    let params = new HttpParams()
      .set('firm_id', this.selectedFirm)
      .set('ordc_status', 'pending')
      .set('ordc_handover_status', 'pending')
      .set('ordc_request_status', 'production_order');
     


    this.orderCreationService.getOrders(params).subscribe((res: any) => {
      const orders = res.data.reverse();
      this.orederCreationDataList = orders;

      if (this.kalakarSuppliers?.length) {
        this.orederCreationDataList = this.mapOrdersWithNames(orders);
      }

      // ✅ IMPORTANT CALLS (हेच missing होतं)
      this.buildRawMaterialConsolidation();
      this.buildKalakarWiseSummary();
      this.buildKalakarWiseMetal();
      this.buildKalakarWiseStone();
      this.buildKalakarWiseMaps();
    });
  }



  private mapOrdersWithNames(orders: any[]) {
    return orders.map((order: any) => {

      // 🔑 HANDLE ALL POSSIBLE ID KEYS
      const assigneeId =
        order.ordc_assined_to ??
        order.assigned_to ??
        order.ordc_assigned_to ??
        order.assignee_id;

      const assignee = this.kalakarSuppliers?.find(
        (u: any) => String(u.id) === String(assigneeId)
      );

      return {
        ...order,
        assignee_id: assigneeId,   // 🔑 canonical id
        assignee_name: assignee
          ? `${assignee.name} ${assignee.user_last_name ?? ''}`.trim()
          : 'Unknown'
      };
    });
  }





  getEnteredQuantity(): number {
    return +this.orderCreationForm.get('ordc_quantity')?.value || 0;
  }

  getMetalProductQuantity(metal: any): number {
    const enteredQty = this.getEnteredQuantity();
    const metalQty = +metal.quantity || 0;
    const productQty = enteredQty * metalQty;
    metal.calculated_product_qty = productQty;
    return productQty;
  }

  getTotalSilverMetal(metal: any): number {
    const productQty = this.getMetalProductQuantity(metal);
    const perPieceWt = +metal.per_piece_weight || 0;
    const total = productQty * perPieceWt;
    metal.total_silver = total;
    return total;
  }

  getStoneProductQuantity(stone: any): number {
    const enteredQty = this.getEnteredQuantity();
    // const stoneQty = +stone.quantity || 0;
    // const productQty = enteredQty * stoneQty;
    stone.calculated_product_qty = enteredQty;
    return enteredQty;
  }

  getTotalStone(stone: any): number {
    const productQty = this.getStoneProductQuantity(stone);
    const stoneQty = +stone.quantity || 0;
    const total = productQty * stoneQty;
    stone.total_stone = total;
    return total;
  }

  updateCalculatedMetalAndStoneData(): void {
    if (!this.completeProductData) return;

    const metalList = this.completeProductData.assembly_metal_part?.map((metal: any) => {
      const calculatedQty = this.getMetalProductQuantity(metal);
      const totalSilver = this.getTotalSilverMetal(metal);
      return {
        ...metal,
        calculated_product_qty: calculatedQty,
        total_silver: totalSilver
      };
    });

    const stoneList = this.completeProductData.assembly_stone?.map((stone: any) => {
      const calculatedQty = this.getStoneProductQuantity(stone);
      const totalStone = this.getTotalStone(stone);
      return {
        ...stone,
        calculated_product_qty: calculatedQty,
        total_stone: totalStone
      };
    });

    // Recalculate totals
    this.totalMetalPrice = metalList?.reduce((sum: number, m: { total_price: string | number; }) => sum + (+m.total_price || 0), 0) || 0;
    this.totalStonePrice = stoneList?.reduce((sum: number, s: { total_price: string | number; }) => sum + (+s.total_price || 0), 0) || 0;
    this.finalValue = this.totalMetalPrice + this.totalStonePrice;

    const formattedMetal = metalList?.length === 1 ? metalList[0] : metalList;
    const formattedStone = stoneList?.length === 1 ? stoneList[0] : stoneList;

    // Patch to form
    this.orderCreationForm.patchValue({
      ordc_metal_details: JSON.stringify(formattedMetal),
      ordc_stone_details: JSON.stringify(formattedStone),
      ordc_metal_price: this.totalMetalPrice,
      ordc_stone_price: this.totalStonePrice,
      ordc_final_value: this.finalValue
    });
  }

  updateLabourCharges(): void {
    const quantityControl = this.orderCreationForm.get('ordc_quantity');
    const labourControl = this.orderCreationForm.get('ordc_labour_charges');

    const quantity = +quantityControl?.value || 0;
    const originalLabourCharge = +this.completeProductData?.latest_product_price?.labour_charges || 0;

    if (!quantity || quantity <= 0) {
      labourControl?.patchValue(originalLabourCharge.toString(), { emitEvent: false });
      return;
    }

    const totalLabourCharge = quantity * originalLabourCharge;
    labourControl?.patchValue(totalLabourCharge.toString(), { emitEvent: false });
  }

  calculateTotalLabourCharges(): void {
    const perPiece = +this.orderCreationForm.get('per_piece_labour_charges')?.value || 0;
    const qty = +this.orderCreationForm.get('ordc_quantity')?.value || 0;

    const total = perPiece * qty;

    this.orderCreationForm.patchValue({
      ordc_labour_charges: total || ''
    }, { emitEvent: false });

    const isApplicable = perPiece > 0;
    this.orderCreationForm.patchValue({
      ordc_is_labour_applicable: isApplicable
    }, { emitEvent: false });
  }

  onHandOverClick(orderId: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to hand over this order?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, hand over',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {

        // 🔥 REMOVE FROM UI FIRST
        this.orederCreationDataList = this.orederCreationDataList.filter(
          (o: Order) => o.id !== orderId
        );
        this.orderCreationService.handOverOrder(orderId).subscribe({
          next: () => {
            this.notificationService.showSuccess(
              'Order Handed Over Successfully!',
              'Success'
            );
          },
          error: (err) => {
            this.notificationService.showError(
              err.error.message || 'Handover failed',
              'Error'
            );

            // ❗ rollback if API fails
            this.getOrderCreationDataList();
          }
        });
      }
    });
  }

  buildKalakarWiseStone() {
    const map = new Map<string, any>();

    this.orederCreationDataList.forEach((order: any) => {
      const kalakarName = order.assignee_name;

      const stones = Array.isArray(order.ordc_stone_details)
        ? order.ordc_stone_details
        : [order.ordc_stone_details];

      stones.forEach((stone: any) => {
        const key = `${kalakarName}_${stone.code}`;

        if (!map.has(key)) {
          map.set(key, {
            kalakar: kalakarName,
            code: stone.code,
            name: stone.stone_name,
            qty_each_product: stone.quantity,
            product_qty: 0,
            total_qty: 0
          });
        }

        const row = map.get(key);
        row.product_qty += Number(stone.calculated_product_qty || 0);
        row.total_qty += Number(stone.total_stone || 0);
      });
    });

    this.kalakarStoneConsolidation = Array.from(map.values());
  }



  buildKalakarWiseMetal() {
    const map = new Map<string, any>();

    this.orederCreationDataList.forEach((order: any) => {
      const kalakarName = order.assignee_name;

      const metals = Array.isArray(order.ordc_metal_details)
        ? order.ordc_metal_details
        : [order.ordc_metal_details];

      metals.forEach((metal: any) => {
        const key = `${kalakarName}_${metal.code}`;

        if (!map.has(key)) {
          map.set(key, {
            kalakar: kalakarName,
            code: metal.code,
            name: metal.artical_name,
            per_piece_weight: metal.per_piece_weight,
            qty_each_product: metal.quantity,
            total_qty: 0,
            total_weight: 0
          });
        }

        const row = map.get(key);
        row.total_qty += Number(metal.calculated_product_qty || 0);
        row.total_weight += Number(metal.total_silver || 0);
      });
    });

    this.kalakarMetalConsolidation = Array.from(map.values());
  }



  focusNext(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const target = keyboardEvent.target as HTMLElement;
    const form = target.closest('form');
    if (!form) return;

    const focusableElements = Array.from(
      form.querySelectorAll<HTMLElement>('input, select, textarea, button')
    ).filter(el =>
      !el.hasAttribute('disabled') &&
      !el.hasAttribute('readonly') &&
      el.tabIndex !== -1 &&
      el.offsetParent !== null // Skips hidden elements
    );

    const currentIndex = focusableElements.indexOf(target);

    if (currentIndex !== -1 && currentIndex + 1 < focusableElements.length) {
      focusableElements[currentIndex + 1].focus();
    }
  }

  returnCount = 0;

  loadReturnCount() {
    this.orderCreationService.getRawMaterialReturnCount().subscribe(res => {
      this.returnCount = res.data.count;
    });
  }

  // updated in the exits table to show kalakar name
  kalakarWiseMetalMap: Record<string, any[]> = {};
  kalakarWiseStoneMap: Record<string, any[]> = {};
  buildKalakarWiseMaps() {
    this.kalakarWiseMetalMap = {};
    this.kalakarWiseStoneMap = {};

    this.kalakarMetalConsolidation.forEach(row => {
      if (!this.kalakarWiseMetalMap[row.kalakar]) {
        this.kalakarWiseMetalMap[row.kalakar] = [];
      }
      this.kalakarWiseMetalMap[row.kalakar].push(row);
    });

    this.kalakarStoneConsolidation.forEach(row => {
      if (!this.kalakarWiseStoneMap[row.kalakar]) {
        this.kalakarWiseStoneMap[row.kalakar] = [];
      }
      this.kalakarWiseStoneMap[row.kalakar].push(row);
    });
  }



}
